/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date: Wed Jan 31 2024 15:49:13
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon, Modal, TextContainer } from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';
import { ReactTypeformEmbed } from 'react-typeform-embed';
import { MobileCancelMajor } from '@shopify/polaris-icons';
import { TYPEFORM_SURVEY } from 'src/constants/typeform-survey';
import * as TranslationActions from 'actions/translation-actions';

type Props = {
  type: string,
  tenantId: string,
  type: string,
  email: string,
  locales: Array<Record<String, any>>,
  getLocales: Function
};

type State = {
  active: boolean
};

type ComposedProps = Props & WithI18nProps;

class GermanyTestSearchEngineSurvey extends Component<ComposedProps, State> {
  state = {
    active: false
  };

  componentDidMount() {
    const { locales = [], getLocales } = this.props;
    if (locales.length === 0) getLocales();
  }

  componentWillReceiveProps(nextProps) {
    try {
      const { tenantId, locales = [] } = nextProps;

      // check submitted form
      const isSubmit = localStorage.getItem(`${tenantId}-GermanyTestSearchEngine-submitted`);
      if (isSubmit === 'true') {
        return;
      }

      // check within 2 days
      const now = moment().startOf();
      const firstDisplay = localStorage.getItem(`${tenantId}-GermanyTestSearchEngine-firstDisplay`);
      if (firstDisplay) {
        if (now.diff(moment(firstDisplay).startOf(), 'day') > 2) {
          return;
        }
      }

      // check already open form in day
      const lastDisplay = localStorage.getItem(`${tenantId}-GermanyTestSearchEngine-lastDisplay`);
      if (now.diff(moment(lastDisplay).startOf(), 'day') === 0) {
        return;
      }

      const hasLocale = _.findIndex(locales, item => item.locale === 'de');
      if (hasLocale > -1) {
        this.setState({ active: true });
      }
    } catch (error) {}
  }

  onClose = () => {
    const { tenantId } = this.props;
    try {
      const firstDisplay = localStorage.getItem(`${tenantId}-GermanyTestSearchEngine-firstDisplay`);
      if (!firstDisplay) {
        localStorage.setItem(
          `${tenantId}-GermanyTestSearchEngine-firstDisplay`,
          moment().toISOString()
        );
      }

      localStorage.setItem(
        `${tenantId}-GermanyTestSearchEngine-lastDisplay`,
        moment().toISOString()
      );
    } catch (error) {
    } finally {
      this.setState({ active: false });
    }
  };

  onSubmit = () => {
    const { tenantId } = this.props;
    try {
      localStorage.setItem(`${tenantId}-GermanyTestSearchEngine-submitted`, 'true');
    } catch (error) {}
  };

  render() {
    const { i18n, type, email, tenantId } = this.props;

    const { active } = this.state;
    const { link, mode } = TYPEFORM_SURVEY[type];
    const linkWithInfo = `${link}?tenant=${tenantId}&email=${email}`;

    return (
      <Modal
        open={active}
        large="large"
        titleHidden
        noScroll
        title={i18n.translate('AdminHTML.Common.FeedbackAfterRating5Stars.PopupForm_title')}>
        <Modal.Section>
          <TextContainer>
            <div className="lucky-modal-container">
              <div className="close" onClick={this.onClose}>
                <Icon source={MobileCancelMajor} color="base" />
              </div>
              <ReactTypeformEmbed
                mode={mode}
                autoOpen={true}
                url={linkWithInfo}
                hideHeaders
                buttonText={i18n.translate('AdminHTML.Common.Action.go')}
                opacity={50}
                ref={tf => {
                  this.typeformEmbed = tf;
                }}
                onSubmit={this.onSubmit}
              />
            </div>
          </TextContainer>
        </Modal.Section>
      </Modal>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  // Locales
  getLocales: () => dispatch(TranslationActions.getLocales(ownProps.i18n))
});

const mapStateToProps = (state, props) => {
  const { translation, oauth } = state;
  const { tenantApp = {} } = oauth;

  const email = _.get(tenantApp, 'externalInfo.email');
  const tenantId = _.get(tenantApp, 'tenantId', '');
  const { locales = [] } = translation;
  return { email, tenantId, locales };
};

export default withI18n()(
  connect(mapStateToProps, mapDispatchToProps)(GermanyTestSearchEngineSurvey)
);
